import React, {useContext} from 'react';
import { BiSolidQuoteAltLeft, BiSolidQuoteAltRight } from "react-icons/bi";
import { LanguageContext } from "../languages/LanguageContext";

const Quote = () => {
    const { language, translations } = useContext(LanguageContext);
    return (
        <div className='quote-container max-w flex jc-c ai-c wrap' id='quote'>
            <BiSolidQuoteAltLeft className='icon' />
            {translations[language]["quote"]}
            <BiSolidQuoteAltRight className='icon' />
        </div>
    );
};

export default Quote;